import React from "react";
import {
  createViewAction,
  formatDate,
  NoWrap,
  numberFormat,
} from "../../../utils/helpers";
import { Link } from "react-router-dom";
import { FormActions } from "../../../components/common/FormActions";

export const useReschedule = () => {
  const tableColumns = () => [
    {
      id: "loan_application",
      header: "Loan Application",
    },
    {
      id: "applicant",
      header: "Applicant",
    },
    {
      id: "number_plate",
      header: "Number Plate",
    },
    {
      id: "proposed_loan_validity_period_months",
      header: "Proposed Loan Validity Period (Months)",
    },
    {
      id: "created_at",
      header: "Created At",
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      applicant: `${item?.first_name} ${item?.other_name || ""} ${item?.last_name}`,
      number_plate: <NoWrap>{item?.number_plate}</NoWrap>,
      loan_application: (
        <Link
          className="link-with-icon"
          to={`/loan_application/view/${item?.loan_application}`}
        >
          {item?.loan_application_number}
        </Link>
      ),
      created_at: <NoWrap>{formatDate(item?.created_at)}</NoWrap>,
      actions: (
        <FormActions
          actions={[createViewAction("/loan_application_reschedule", item?.id)]}
        />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Rescheduled Loan Application",
          fields: {
            loan_application: (
              <Link
                className="link-with-icon"
                to={`/loan_application/view/${item?.loan_application}`}
              >
                {item?.loan_application_number}
              </Link>
            ),
            application_type: item?.application_type,
            applicant: `${item?.first_name} ${item?.other_name || ""} ${item?.last_name}`,
            number_plate: item?.number_plate,
            vehicle_type_name: item?.vehicle_type_name,
            loan_type: item?.loan_type,
            total_amount_payable: numberFormat(item?.total_amount_payable),
            current_loan_validity_period_months:
              item?.current_loan_validity_period_months,
            current_loan_validity_period_years:
              item?.current_loan_validity_period_years,
          },
        },
        {
          title: "Rescheduled Details",
          fields: {
            status: item?.status,
            repayment_period: item?.repayment_period,
            amortization_method: item?.amortization_method,
            proposed_loan_validity_period_months:
              item?.proposed_loan_validity_period_months,
            proposed_loan_validity_period_years:
              item?.proposed_loan_validity_period_years,
            reason_for_rescheduling: item?.reason_for_rescheduling,
            created_at: formatDate(item?.created_at),
          },
        },
      ],
    };
  };
  const activityFilter = "loan_application_reschedule";

  return { tableColumns, tableData, viewData, activityFilter };
};
